/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { PERSON_MEDIA_TYPES } from '@repo/config';
import { z } from 'zod';

export const personPhotoSchema = z.object({
  id: z.number(),
  personId: z.number(),
  mediaType: z.enum(PERSON_MEDIA_TYPES),
  path: z.string().nullable().optional(),
  sourceUrl: z.string().nullable().optional(),
  width: z.number().nullable().optional(),
  height: z.number().nullable().optional(),
  caption: z.string().nullable().optional(),
  sortOrder: z.number(),
  createdAt: z.number(),
});

export type IPersonPhoto = z.infer<typeof personPhotoSchema>;
